import { useState, useEffect } from "react";
import { useAuth } from "../hooks/useAuth";
import Auth from "./auth";
import Main from "./main";

export default function Index() {
  const { signed } = useAuth();
  const [isSigned, setSigned] = useState(false);

  useEffect(() => {
    setSigned(signed);
  }, [signed]);

  return isSigned ? <Main /> : <Auth />;
}
